import { render, staticRenderFns } from "./AddMarketBlacklist.vue?vue&type=template&id=53db9a0e"
import script from "./AddMarketBlacklist.vue?vue&type=script&lang=js"
export * from "./AddMarketBlacklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports